import { render, staticRenderFns } from "./TransactionPair.vue?vue&type=template&id=c23a112e&scoped=true&"
import script from "./TransactionPair.vue?vue&type=script&lang=js&"
export * from "./TransactionPair.vue?vue&type=script&lang=js&"
import style0 from "./TransactionPair.vue?vue&type=style&index=0&id=c23a112e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23a112e",
  null
  
)

export default component.exports